<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
<!--                        {{ $tc('message.commonParameters', 1) }}-->
                        {{$t('message.parameter') }}
                    </h3>
                </div>
            </div>

            <div class="card-body">
                <div class="card">
                    <b-container>
                        <div class="list-group list-group-flush">
                            <b-row>
                                <b-col col sm="12">
                                    <div class="list-group-item">
                                        {{ $t('message.weight') }}:

                                        <span class="font-weight-bold">
                                {{ mParameter.poids }}
                            </span>
                                    </div>
                                </b-col>

                                <b-col col sm="12">
                                    <div class="list-group-item">
                                        {{ $t('message.height') }}:

                                        <span class="font-weight-bold">
                                {{ mParameter.taille }}
                            </span>
                                    </div>
                                </b-col>

                                <b-col col sm="12">
                                    <div class="list-group-item">
                                        {{ $t('message.bmi') }}:

                                        <span class="font-weight-bold">
                                {{ mParameter.bmi }}
                            </span>
                                    </div>
                                </b-col>

                                <b-col col sm="12" v-if="mParameter.communable_type == 'Cardiologie'">
                                    <div class="list-group-item">
                                        {{ $t('message.abdoPerimetre') }}:

                                        <span class="font-weight-bold">
                                {{ mParameter.perimetre_abdominal }}
                            </span>
                                    </div>
                                </b-col>

                                <b-col col sm="12">
                                    <div class="list-group-item">
                                        {{ $t('message.taSystoliqueL') }}:

                                        <span class="font-weight-bold">
                                {{ mParameter.ta_systolique }}
                            </span>
                                    </div>
                                </b-col>

                                <b-col col sm="12">
                                    <div class="list-group-item">
                                        {{ $t('message.taDiastoliqueL') }}:

                                        <span class="font-weight-bold">
                                {{ mParameter.ta_diastolique }}
                            </span>
                                    </div>
                                </b-col>

                                <b-col col sm="12">
                                    <div class="list-group-item">
                                        {{ $t('message.taSystoliqueD') }}:

                                        <span class="font-weight-bold">
                                {{ mParameter.ta_systolique_d }}
                            </span>
                                    </div>
                                </b-col>

                                <b-col col sm="12">
                                    <div class="list-group-item">
                                        {{ $t('message.taDiastoliqueD') }}:

                                        <span class="font-weight-bold">
                                {{ mParameter.ta_diastolique_d }}
                            </span>
                                    </div>
                                </b-col>

                                <b-col col sm="12">
                                    <div class="list-group-item">
                                        {{ $t('message.temperature') }}:

                                        <span class="font-weight-bold">
                                {{ mParameter.temperature }}
                            </span>
                                    </div>
                                </b-col>

                                <b-col col sm="12">
                                    <div class="list-group-item">
                                        {{ $t('message.heartRate') }}:

                                        <span class="font-weight-bold">
                                {{ mParameter.frequence_cardiaque }}
                            </span>
                                    </div>
                                </b-col>

                                <b-col col sm="12">
                                    <div class="list-group-item">
                                        {{ $t('message.respiratoryRate') }}:

                                        <span class="font-weight-bold">
                                {{ mParameter.frequence_respiratoire }}
                            </span>
                                    </div>
                                </b-col>

                                <b-col col sm="12">
                                    <div class="list-group-item">
                                        {{ $t('message.sato2') }}:

                                        <span class="font-weight-bold">
                                {{ mParameter.sato2 }}
                            </span>
                                    </div>
                                </b-col>
                            </b-row>
                            <b-row class="justify-content-center" >
                                <div class="card-footer text-right">
                                    <b-button variant="primary" @click="updateParameter" v-if="mParameter.isAuthor || mParameter.canUpdate || hasAdminRole">
                                        {{ $t('message.edit') }}
                                    </b-button>

                                    <b-button v-b-modal.delete-modal variant="danger" v-if="mParameter.isAuthor  || hasAdminRole">
                                        {{ $t('message.delete') }}
                                    </b-button>
                                </div>
                            </b-row>
                        </div>
                    </b-container>
                    <b-modal
                            id="delete-modal"
                            size="sm"
                            header-bg-variant="danger"
                            header-text-variant="light"
                            :title="$t('message.delete') + ' ' + $tc('message.commonParameters', 1)"
                            hide-footer
                    >
                        <div class="d-block text-center">
                            <h3>{{ $t('message.delete') }} {{ mParameter.poids }}?</h3>
                        </div>

                        <div class="d-block float-right" v-if="mParameter.isAuthor || hasAdminRole">
                            <b-button variant="danger" @click="deleteParameter">
                                {{ $t('message.delete') }}
                            </b-button>

                            <b-button variant="secondary" @click="$bvModal.hide('delete-modal')">
                                {{ $t('message.cancel') }}
                            </b-button>
                        </div>
                    </b-modal>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {
        name: "Common",

        computed: {
            ...mapGetters(["commonParameter", "hasAdminRole", "hasMedecinControleRole", "hasPraticienRole","hasAssistante"]),

            can: function (){
                if (this.hasAdminRole){
                    return true;
                }else{
                    return this.hasMedecinControleRole || this.hasPraticienRole || this.hasAssistante;
                }
            },
            mParameter: function() {
                return this.commonParameter;
            }
        },

        data() {
            return {
                parameter_id: this.$route.params.parameter
            }
        },

        methods: {
            getParameter() {
                let args = {
                    parametreCommun: this.parameter_id
                };

                this.$store.dispatch("getCommonParameter", { args });
            },

            updateParameter() {
                this.$router.push({ name: 'edit-parameter-common', params: { parameter: this.parameter_id } });
            },

            deleteParameter() {
                let self = this;
                let args = {
                    parametreCommun: this.parameter_id
                };

                let successMessage = this.$i18n.t('message.commonParameterDeleted');
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.error')
                };

                this.$store.dispatch('deleteCommonParameter', { args, index: self.parameter_id, successMessage, errorMessages }).then(() => {
                    self.$bvModal.hide('delete-modal');
                    this.$router.back();

                });
            }
        },

        mounted() {
            this.getParameter();
        }
    }
</script>

<style scoped>

</style>